import { AtLinkProps, OrFooterProps } from '@curran-catalog/curran-atomic-library'

import { ContentfulOrFooter, SiteDomain } from 'types'
import { normalizeLink } from '.'
import { environment } from '@config/environment'

export const normalizeFooter = (footer: ContentfulOrFooter, path: string): OrFooterProps => {
  const { logoLink, copyright, socialMediaLinks, menuItems } = footer
  const isSynsisal = environment.siteDomain === SiteDomain.SYNSISAL
  return {
    copyright: copyright ?? '',
    logoLink: logoLink ? normalizeLink(logoLink, true) : undefined, // ✅ same pattern as header
    colorTheme: isSynsisal ? 'kelp' : 'moss',
    socialLinks: socialMediaLinks?.map((socialLink) => normalizeLink(socialLink, false)) ?? [],
    menuItems:
      menuItems?.map(({ title, subItems }) => ({
        title: normalizeLink(title),
        subItems: subItems?.map((subItem) => ({
          ...normalizeLink(subItem),
          active: path === subItem.actionUrl,
        })) as AtLinkProps[],
      })) ?? [],
  }
}
